/**
 * Bewaarde weergavekeuze van de helpdeskticketlijst: "recent" (vlakke lijst,
 * nieuwste eerst, met paginatie) of "building" (gegroepeerd per gebouw en unit).
 *
 * Zelfde patroon als `useRenoListViewMode` bij de renovatietickets: de keuze
 * staat in localStorage, zodat wie per gebouw werkt daar terugkomt.
 *
 * @module Helpdesk/Shared/Hooks/UseHelpdeskListViewMode
 */

import { useCallback, useState } from "react";

export type HelpdeskListViewMode = "recent" | "building";

const STORAGE_KEY = "helpdeskListViewModeV1";

export function useHelpdeskListViewMode() {
  const [viewMode, setViewModeState] = useState<HelpdeskListViewMode>(() => {
    try {
      return localStorage.getItem(STORAGE_KEY) === "building"
        ? "building"
        : "recent";
    } catch {
      return "recent";
    }
  });

  const setViewMode = useCallback((mode: HelpdeskListViewMode) => {
    setViewModeState(mode);
    try {
      localStorage.setItem(STORAGE_KEY, mode);
    } catch {
      // localStorage kan geblokkeerd zijn; de weergave werkt dan zonder bewaren.
    }
  }, []);

  return { viewMode, setViewMode };
}
